<template>
    <div class="store-search">
        <div class="title">
            <h2>服务门店查询</h2>
        </div>
        <div class="illustrate">
            <p>全国加盟店与区域销售商是依据其专心致力于服务品质而精心挑选的。他们都需要进过最新的施工技术的专业培训，才有资格为广大消费者提供优质的施工服务。欢迎点击一下图标来查询您附近的加盟商、经销商。</p>
        </div>
        <div class="select" style="margin-top: 30px;">
            <el-select v-model="value5" multiple placeholder="请选择">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>

            <el-select
                    v-model="value11"
                    multiple
                    collapse-tags
                    style="margin-left: 20px;"
                    placeholder="请选择">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="map-box" style="margin-top: 50px;padding: 0 10px;">
            <div class="map">
                <el-amap vid="amapDemo" :zoom="zoom" :center="center">
                </el-amap>
            </div>
            <div class="right"></div>
        </div>
    </div>
</template>

<script>
import loading from '../common/loading.vue'
export default {
  name: 'storeSearch',
  data () {
    return {
      msg: '门店查询',
      isLoad: true,
      zoom: 16,
      center: [113.367834, 23.178768],
      // 选择框
      options: [{
        value: '选项1',
        label: '广东省'
      }, {
        value: '选项2',
        label: '福建省'
      }, {
        value: '选项3',
        label: '安徽省'
      }, {
        value: '选项4',
        label: '河南省'
      }, {
        value: '选项5',
        label: '浙江省'
      }, {
        value: '选项6',
        label: '浙江省'
      }, {
        value: '选项7',
        label: '浙江省'
      }, {
        value: '选项8',
        label: '浙江省'
      }],
      value5: [],
      value11: []
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.isLoad = false
  },
  methods: {
  },
  filters: {
  },
  components: {
    loading
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .store-search{
        padding: 50px 0;
        width: 1200px;
        margin: 0 auto;
    }
    .title{
        margin-top: 50px;
    }
    .illustrate{
        margin-top: 30px;
        padding: 0 100px;
        line-height: 30px;
        color: #b7b7b7;
    }
    .map{
        width: 820px;
        height: 450px;
        display: inline-block;
    }
    .right{
        width: 360px;
        height: 450px;
        display: inline-block;
        border: 2px solid #cccccc;
        border-left: none;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/components/install/storeSearch.vue